import type { JSX } from "react";

/** A spinner over a picture of you while the background blur starts, so the
 * wait reads as loading rather than as nothing happening (Adam, 2026-10-18:
 * "Make sure that when blur is loading in on any surface there's some
 * spinner"). Its parent must be positioned. */
export function BlurLoading({ show }: { readonly show: boolean }): JSX.Element | null {
  if (!show) return null;
  return (
    <div className="blurload" role="status" aria-label="Blurring your background" data-testid="blur-loading">
      <span className="callspin" aria-hidden="true" />
    </div>
  );
}
